import { render, staticRenderFns } from "./RamVmChart.vue?vue&type=template&id=44f383c2&scoped=true&"
import script from "./RamVmChart.vue?vue&type=script&lang=js&"
export * from "./RamVmChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f383c2",
  null
  
)

export default component.exports